/*************************************************************************
 *
 *  Copyright 2020 Adobe
 *  All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import { mergeQuads } from "../Utils/SelectionUtils";

export const getPageQuadsArray = (stores, pageIndex) => {
  const quads = stores.pageHighlightsStore.pagesQuadsArrayMap.get(pageIndex);
  return quads || [];
};

export const getLeftMostQuad = (stores, pageIndex) => {
  const quadsArray = getPageQuadsArray(stores, pageIndex);
  return quadsArray.length && quadsArray[0];
};

export const getRightMostQuad = (stores, pageIndex) => {
  const quadsArray = getPageQuadsArray(stores, pageIndex);
  return quadsArray.length && quadsArray[quadsArray.length - 1];
};

export const getCanvasQuadsUnion = (stores, pageIndex) => {
  const shouldMergeCallback = () => ({ shouldMerge: true }); // merge all quads
  const mergedQuads = mergeQuads(
    getPageQuadsArray(stores, pageIndex).slice(),
    shouldMergeCallback
  );
  if (mergedQuads.length === 1) {
    return mergedQuads[0].polygonBoundsUnion;
  }
  return {};
};

export const getCanvasOperation = stores =>
  stores.pageHighlightsStore.canvasOperation;
